(function () {
  var D = window.CAMARA_DATA, SVG = window.CAMARA_SVG, CFG = window.CAMARA_CFG || {};
  var root = document.getElementById('camara');
  if (!root || !D) return;
  var HIDE = (CFG.hide || []).filter(Boolean);
  if (HIDE.length) { D.recs = D.recs.filter(function (r) { return HIDE.indexOf(r.b || 1) < 0 || (CFG.owned && CFG.owned[String(r.b)]); }); HIDE.forEach(function (b) { if (D.books && !(CFG.owned && CFG.owned[String(b)])) delete D.books[String(b)]; }); }
  var STEPS = CFG.steps || {};
  var ING = {}; D.ing.forEach(function (i) { ING[i.id] = i; });
  var REC = {}; D.recs.forEach(function (r) { REC[r.id] = r; });
  var KEY = 'camara-bunicii-v1';
  var sel = new Set(), chapter = -1, book = 1, onlyNow = false, shown = 24;
  var BOOKS = D.books || {}, OWN = (typeof CFG.owned === 'object' && CFG.owned) ? CFG.owned : { '1': !!CFG.owned }, BUY = CFG.books || {};
  function owned(b) { return !!OWN[String(b)]; }
  function dailyId() { var d = CFG.daily; return typeof d === 'object' ? +d[String(book)] : +d; }
  var LEAD = { '1': 'Bifează ce ai în frigider și în cămară. Îți arătăm ce mâncare ardelenească, ca la bunica, poți face chiar acum din cele 100 de rețete ale cărții.', '2': 'Bifează ce ai în frigider și în cămară. Îți arătăm ce poți găti chiar acum din cele 54 de rețete ale bunicilor maghiare din Ardeal.', '3': 'Bifează ce ai în frigider. Îți arătăm ce poți face chiar acum în air fryer, din cele 80 de rețete rapide și sănătoase ale cărții.' };
  function bk(r) { return BOOKS[String(r.b || 1)] || { t: '', n: 0, lbl: 'SFATUL', tag: '' }; }
  var BASICS = ['faina', 'oua', 'ceapa', 'usturoi', 'zahar', 'otet', 'boia', 'dafin', 'malai', 'orez', 'unt', 'lapte'];

  function $(s, el) { return (el || root).querySelector(s); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function load() {
    try {
      var q = new URLSearchParams(location.search).get('i');
      if (q) { q.split(',').forEach(function (x) { if (ING[x]) sel.add(x); }); return; }
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      v.forEach(function (x) { if (ING[x]) sel.add(x); });
    } catch (e) {}
  }
  function save() { try { localStorage.setItem(KEY, JSON.stringify(Array.from(sel))); } catch (e) {} }
  function toast(t) { var el = $('.toast'); el.textContent = t; el.classList.add('on'); clearTimeout(el._t); el._t = setTimeout(function () { el.classList.remove('on'); }, 2200); }

  // ---------- chips
  function renderChips() {
    var groups = {}, order = [];
    var used = {}; D.recs.forEach(function (r) { if ((r.b || 1) !== book) return; r.core.forEach(function (t) { used[t] = 1; }); r.il.forEach(function (l) { l.forEach(function (t) { used[t] = 1; }); }); });
    D.ing.forEach(function (i) { if (!used[i.id] && !sel.has(i.id)) return; if (!groups[i.g]) { groups[i.g] = []; order.push(i.g); } groups[i.g].push(i); });
    var h = '';
    order.forEach(function (g) {
      h += '<div class="grp"><h3>' + esc(g) + '</h3><div class="chips">';
      groups[g].forEach(function (i) {
        h += '<button type="button" class="chip" data-id="' + i.id + '" aria-pressed="' + sel.has(i.id) + '">' + esc(i.l) + '</button>';
      });
      h += '</div></div>';
    });
    $('#chipbox').innerHTML = h;
  }
  function syncChips() {
    root.querySelectorAll('.chip').forEach(function (c) { c.setAttribute('aria-pressed', sel.has(c.dataset.id)); });
  }

  // ---------- scoring
  var EQ = { slanina: ['afumatura'], tocata: ['porc', 'vita'], ceapa_verde: ['ceapa'] };
  function has(t) { return sel.has(t) || (EQ[t] || []).some(function (x) { return sel.has(x); }); }
  function score(r) {
    var have = r.core.filter(has);
    var miss = r.core.filter(function (t) { return !has(t); });
    return { r: r, have: have, miss: miss, ratio: r.core.length ? have.length / r.core.length : 0 };
  }
  function results() {
    var list = D.recs.filter(function (r) { return (r.b || 1) === book && (chapter < 0 || r.c === chapter); }).map(score);
    if (sel.size) {
      list = list.filter(function (s) { return s.have.length > 0 && (s.miss.length <= 2 || s.ratio >= 0.6); });
      if (onlyNow) list = list.filter(function (s) { return s.miss.length === 0; });
      list.sort(function (a, b) { return a.miss.length - b.miss.length || b.have.length - a.have.length || b.ratio - a.ratio; });
    }
    return list;
  }
  function names(ids) { return ids.map(function (t) { return ING[t].l.split(' / ')[0].toLowerCase(); }).join(', '); }

  function renderResults() {
    var list = results();
    var now = sel.size ? list.filter(function (s) { return s.miss.length === 0; }).length : 0;
    $('#rescount').textContent = list.length;
    $('#restitle').textContent = sel.size ? 'Ce poți găti' : 'Toate rețetele';
    $('#ressub').textContent = sel.size
      ? (now ? 'Poți face chiar acum ' + now + (now === 1 ? ' rețetă' : ' rețete') + '. Celelalte au nevoie de 1–2 lucruri în plus.' : 'Îți lipsesc doar 1–2 ingrediente. Mai bifează ce ai prin casă.')
      : 'Bifează mai sus ce ai în frigider și în cămară, iar rețetele se aranjează după ce poți face acum.';
    var h = '';
    if (!list.length) {
      h = '<div class="empty">Nicio rețetă din această carte nu se potrivește încă. Mai bifează câteva ingrediente de bază (ceapă, ouă, făină) sau încearcă altă carte.</div>';
    } else {
      list.slice(0, shown).forEach(function (s) {
        var r = s.r;
        h += '<button type="button" class="card" data-id="' + r.id + '"><div class="ill" aria-hidden="true">' + SVG[r.k] + '</div>' +
          '<span class="z">' + esc(D.chapters[r.c]) + ' · ' + esc(r.z.split(',')[0]) + (r.post ? ' · de post' : (r.u ? ' · ușoară' : '')) + '</span><h4>' + esc(r.t) + '</h4>';
        if (sel.size) {
          h += '<div class="meter" aria-hidden="true"><i style="width:' + Math.round(s.ratio * 100) + '%"></i></div>' +
            '<span class="have">' + (s.miss.length ? 'Ai ' + s.have.length + ' din ' + r.core.length + ' ingrediente' : '✓ Ai tot ce trebuie') + '</span>';
          if (s.miss.length) h += '<span class="miss">Îți lipsește: <b>' + esc(names(s.miss)) + '</b></span>';
        } else {
          h += '<span class="miss">' + esc(r.tm) + ' · ' + esc(r.d) + '</span>';
        }
        h += '</button>';
      });
    }
    $('#grid').innerHTML = h;
    $('#morewrap').style.display = list.length > shown ? '' : 'none';
    var bar = $('.bar');
    bar.classList.toggle('on', sel.size > 0);
    $('#bartxt').innerHTML = '<b>' + list.length + '</b> rețete' + (now ? ', <b>' + now + '</b> chiar acum' : '') + '<br><span style="opacity:.75">' + sel.size + ' ingrediente bifate</span>';
  }

  function update() { save(); syncChips(); shown = 24; renderResults(); }

  // ---------- modal
  var lastFocus = null, wake = null;
  function lineOk(tags, line) {
    if (!tags.length) return /\b(sare|piper|apă|ulei)\b/i.test(line);
    return tags.every(has);
  }
  function openRecipe(id, push) {
    var r = REC[id]; if (!r) return;
    lastFocus = document.activeElement;
    var st = STEPS[id];
    var B = bk(r), ob = owned(r.b || 1), buy = BUY[String(r.b || 1)] || {};
    var h = '<div class="top"><span class="sans" style="font-size:13px;color:var(--muted)">' + esc(B.t) + ' · rețeta ' + (r.n || r.id) + ' din ' + B.n + (r.pg ? ' · pagina ' + r.pg : '') + '</span>' +
      '<button type="button" class="x" data-close aria-label="Închide">×</button></div>' +
      '<div class="ill" aria-hidden="true">' + SVG[r.k] + '</div><div class="z">' + esc(D.chapters[r.c]) + ' · ' + esc(r.z) + '</div>' +
      '<h2 id="mt">' + esc(r.t) + '</h2><div class="meta">' + esc(r.p) + ' · ' + esc(r.tm) + ' · ' + esc(r.d) + '</div>' +
      '<p class="story">' + esc(r.s) + '</p><h3>Ingrediente</h3><ul class="ings">';
    r.ing.forEach(function (line, i) { h += '<li class="' + (sel.size && lineOk(r.il[i], line) ? 'ok' : '') + '">' + esc(line) + '</li>'; });
    h += '</ul><h3>Cum se face</h3>';
    if (st) {
      if (!ob && dailyId() === r.id) h += '<p class="sub" style="margin:0 0 10px">🎁 <b>Rețeta zilei</b> e deschisă azi pentru toată lumea. Atinge un pas ca să-l tai când l-ai terminat.</p>';
      else h += '<p class="sub" style="margin:0 0 10px">Atinge un pas ca să-l tai când l-ai terminat. Ecranul rămâne aprins cât gătești.</p>';
      h += '<ol class="stp">' + st.pasi.map(function (p) { return '<li>' + esc(p) + '</li>'; }).join('') + '</ol>' +
        '<div class="secret"><b>' + esc(B.lbl) + '</b><p>' + esc(st.secret) + '</p></div>';
    } else {
      h += '<div class="lock"><p><b>Pașii și ' + (r.b === 3 ? 'sfatul' : 'secretul bunicii') + '</b> sunt în cartea <i>' + esc(B.t) + '</i>' + (r.pg ? ', la pagina ' + r.pg : '') + '. Cu cartea, aplicația îți arată pașii la toate cele ' + B.n + ' de rețete din ea.</p><div class="row">' +
        '<a class="btn solid" href="' + (buy.url || CFG.buy) + '">Vreau cartea' + (buy.price ? ' · ' + esc(buy.price) : '') + '</a>';
      if (CFG.loggedIn) h += '<a class="btn ghost" href="' + CFG.logout + '">Am cumpărat cu alt email</a>';
      else h += '<a class="btn ghost" href="' + CFG.login + '">Am cartea, intru cu emailul</a>';
      h += '</div>' + (CFG.loggedIn ? '<p class="sub" style="margin:10px 0 0">Nu găsim această carte pe contul ' + esc(CFG.email || '') + '. Dacă abia ai plătit, mai încearcă peste un minut.</p>' : '') + '</div>';
    }
    h += '<div class="share"><button type="button" class="btn solid" data-share="' + r.id + '">Trimite rețeta</button>' +
      '<button type="button" class="btn" data-cooked="' + r.id + '">Am gătit-o! 🍲</button></div>' +
      (r.src ? '<p class="src">Sursa: ' + esc(r.src) + '</p>' : '');
    var sheet = $('.sheet'); sheet.innerHTML = h; sheet.scrollTop = 0;
    var ov = $('.ov'); ov.classList.add('on'); document.documentElement.style.overflow = 'hidden';
    $('.x', sheet).focus();
    if (push !== false) try { history.pushState({ r: id }, '', '#reteta-' + id); } catch (e) {}
    if (st && navigator.wakeLock) navigator.wakeLock.request('screen').then(function (w) { wake = w; }).catch(function () {});
  }
  function closeRecipe(fromPop) {
    var ov = $('.ov'); if (!ov.classList.contains('on')) return;
    ov.classList.remove('on'); document.documentElement.style.overflow = '';
    if (wake) { try { wake.release(); } catch (e) {} wake = null; }
    if (!fromPop && /^#reteta-/.test(location.hash)) try { history.back(); } catch (e) {}
    if (lastFocus) lastFocus.focus();
  }

  // ---------- sharing (the viral loop)
  function pageUrl(extra) { return location.origin + location.pathname + (extra || ''); }
  function share(text, url) {
    if (navigator.share) { navigator.share({ title: 'Ce gătesc azi? · Lokness', text: text, url: url }).catch(function () {}); return; }
    var full = text + ' ' + url;
    if (navigator.clipboard) navigator.clipboard.writeText(full).then(function () { toast('Link copiat. Trimite-l pe WhatsApp!'); }, function () { window.open('https://wa.me/?text=' + encodeURIComponent(full), '_blank'); });
    else window.open('https://wa.me/?text=' + encodeURIComponent(full), '_blank');
  }

  // ---------- events
  root.addEventListener('click', function (e) {
    var t = e.target.closest('button, a'); if (!t || !root.contains(t)) {
      if (e.target.classList && e.target.classList.contains('ov')) closeRecipe();
      return;
    }
    if (t.classList.contains('chip')) { var id = t.dataset.id; sel.has(id) ? sel.delete(id) : sel.add(id); update(); return; }
    if (t.classList.contains('card')) { openRecipe(+t.dataset.id); return; }
    if (t.dataset.close !== undefined) { closeRecipe(); return; }
    if (t.dataset.ch !== undefined) {
      chapter = +t.dataset.ch; root.querySelectorAll('[data-ch]').forEach(function (p) { p.setAttribute('aria-pressed', +p.dataset.ch === chapter); });
      shown = 24; renderResults(); return;
    }
    if (t.dataset.bk !== undefined) { setBook(+t.dataset.bk); return; }
    if (t.id === 'onlynow') { onlyNow = !onlyNow; t.setAttribute('aria-pressed', onlyNow); renderResults(); return; }
    if (t.id === 'basics') { BASICS.forEach(function (x) { sel.add(x); }); update(); toast('Am bifat ce are orice cămară'); return; }
    if (t.id === 'clear') { sel.clear(); update(); return; }
    if (t.id === 'more') { shown += 24; renderResults(); return; }
    if (t.id === 'seeres' || t.id === 'barbtn') { $('#results').scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    if (t.id === 'daily') { openRecipe(dailyId()); return; }
    if (t.id === 'sharefridge') {
      share('Uite ce pot găti din ce am în frigider:', pageUrl('?carte=' + book + '&i=' + Array.from(sel).join(','))); return;
    }
    if (t.dataset.share) { var r = REC[t.dataset.share]; share('Diseară fac „' + r.t + '”' + (r.b === 3 ? ', la air fryer' : ', rețetă tradițională din ' + r.z.split(',')[0]) + '. Vezi ce poți găti și tu din ce ai în frigider:', pageUrl('#reteta-' + r.id)); return; }
    if (t.dataset.cooked) {
      var c = REC[t.dataset.cooked];
      try { var k = 'camara-gatite'; var g = JSON.parse(localStorage.getItem(k) || '[]'); if (g.indexOf(c.id) < 0) g.push(c.id); localStorage.setItem(k, JSON.stringify(g)); var n = g.length; } catch (e2) { n = 1; }
      var cb = bk(c); share(c.b === 3 ? 'Am gătit „' + c.t + '” în air fryer! ' + cb.tag : 'Am gătit „' + c.t + '” ca la bunica! Am bifat ' + n + ' rețete în Provocarea Colțul bunicii. ' + cb.tag, pageUrl('#reteta-' + c.id));
      return;
    }
    if (t.closest('.stp')) return;
  });
  root.addEventListener('click', function (e) { var li = e.target.closest('.stp li'); if (li) li.classList.toggle('done'); });
  $('.ov').addEventListener('click', function (e) { if (e.target === this) closeRecipe(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeRecipe(); });
  window.addEventListener('popstate', function () {
    var m = /^#reteta-(\d+)/.exec(location.hash);
    if (m) openRecipe(+m[1], false); else closeRecipe(true);
  });
  $('#find').addEventListener('input', function () {
    var q = this.value.trim().toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    root.querySelectorAll('.chip').forEach(function (c) {
      var l = c.textContent.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      c.classList.toggle('hide', q && l.indexOf(q) < 0);
    });
    root.querySelectorAll('.grp').forEach(function (g) { g.style.display = g.querySelector('.chip:not(.hide)') ? '' : 'none'; });
  });

  // ---------- init
  load();
  function renderPills() {
    var p = '', chs = [];
    D.recs.forEach(function (r) { if ((r.b || 1) === book && chs.indexOf(r.c) < 0) chs.push(r.c); });
    p += '<button type="button" class="pill" data-ch="-1" aria-pressed="' + (chapter < 0) + '">Toate capitolele</button>';
    chs.forEach(function (i) { p += '<button type="button" class="pill" data-ch="' + i + '" aria-pressed="' + (chapter === i) + '">' + esc(D.chapters[i]) + '</button>'; });
    p += '<button type="button" class="pill" id="onlynow" aria-pressed="' + onlyNow + '">✓ Doar ce pot face acum</button>';
    $('#pills').innerHTML = p;
    var tb = $('#booktabs');
    if (tb) {
      var h = '';
      Object.keys(BOOKS).forEach(function (k) { h += '<button type="button" role="tab" class="' + (k === '3' ? 'af' : '') + '" data-bk="' + k + '" aria-selected="' + (book === +k) + '">' + esc(BOOKS[k].t) + '<small>' + BOOKS[k].n + ' de rețete' + (owned(k) ? ' · ale tale' : '') + '</small></button>'; });
      tb.innerHTML = h; tb.style.display = Object.keys(BOOKS).length > 1 ? '' : 'none';
    }
  }
  function renderDaily() {
    var dr = REC[dailyId()];
    if (dr && (dr.b || 1) === book) { $('#daily').style.display = ''; $('#daily .ill').innerHTML = SVG[dr.k]; $('#daily .t').textContent = dr.t; } else { $('#daily').style.display = 'none'; }
  }
  function setBook(b, quiet) {
    if (!BOOKS[String(b)]) b = +Object.keys(BOOKS)[0] || 1;
    book = b; chapter = -1; shown = 24;
    root.classList.remove('bk1', 'bk2', 'bk3'); root.classList.add('bk' + b);
    try { localStorage.setItem('camara-carte', String(b)); } catch (e) {}
    var ld = document.getElementById('lead'); if (ld && LEAD[String(b)]) ld.textContent = LEAD[String(b)];
    root.querySelectorAll('.promos [data-book]').forEach(function (el) { el.style.display = el.dataset.book === String(b) ? '' : 'none'; });
    renderPills(); renderDaily();
    if (!quiet) { renderChips(); renderResults(); }
  }
  (function () {
    var q = null; try { q = new URLSearchParams(location.search).get('carte'); } catch (e) {}
    if (!q) { var m0 = /^#reteta-(\d+)/.exec(location.hash); if (m0 && REC[+m0[1]]) q = REC[+m0[1]].b || 1; }
    if (!q) try { q = localStorage.getItem('camara-carte'); } catch (e) {}
    setBook(+q || 1, true);
  })();
  renderChips(); renderResults();
  var m = /^#reteta-(\d+)/.exec(location.hash); if (m) openRecipe(+m[1], false);
})();
